import React from 'react';
import { Section } from './Section';
export function BigIdea() {
  return <Section background="forest" labelledBy="big-idea-heading" data-id="element-30" data-mp="2p9ycnpdqrmbr">
      <div className="mx-auto max-w-3xl text-center" data-id="element-31" data-mp="2p852i03x6jz0">
        <h2 id="big-idea-heading" className="font-serif text-[27px] font-semibold leading-[1.15] text-white sm:text-3xl lg:text-[40px]" data-id="element-32" data-mp="2u8roldddr59t">
          The difference between the teacher who freezes and the teacher who answers isn't training
          hours.
        </h2>

        <p className="mt-7 font-serif text-3xl font-medium italic leading-tight text-brass sm:text-[44px]" data-id="element-33" data-mp="26ix9sq9i36mx">
          It's retrieval.
        </p>

        <div className="mt-8 space-y-5 font-sans text-[17px] leading-[1.65] text-white/70 sm:text-lg" data-id="element-34" data-mp="2bh8njc2x21af">
          <p data-id="element-35" data-mp="2gbcuhvc6m9bi">
            Teachers with 500 hours report feeling more hesitant after advanced study, not less —
            because the more anatomy you know, the more conditions you see when you look around the
            room. A 200-hour training has to cover philosophy, sequencing, breath, ethics,
            methodology and anatomy. It was never going to also hand you a response to every
            condition that walks through the door. That's not a failure of your training. That's
            arithmetic.
          </p>
          <p data-id="element-36" data-mp="2gam9awf0hhj0">
            So the gap was never what you know. It's whether you can reach it, under social
            pressure, in a few seconds.
          </p>
          <p className="font-medium text-white" data-id="element-37" data-mp="2bcktqlgso0ca">
            Retrieval problems aren't solved by more study. They're solved by systems.
          </p>
        </div>
      </div>
    </Section>;
}